import { FormDataAPIType, FormRendererProps } from 'components/common/form/index';
import usePageForm from 'components/common/form/hooks/usePageForm';
import { useEffect } from 'react';
import useBundleTranslation from 'i18n';
import useFormTabs from 'components/common/form/hooks/useFormTabs';

export default function useCustomSimplifiedForm(
    defaultValues: any = {},
    formRendererProps?: FormRendererProps,
): FormDataAPIType {
    const { t } = useBundleTranslation();
    const tabs = useFormTabs(
        false,
        formRendererProps?.formSettings ?? { tabs: [], uid: '0' },
        formRendererProps?.entityId ?? '',
    );

    const hookForm = usePageForm(defaultValues, t, formRendererProps, tabs);
    useEffect(() => {
        hookForm.form.setFormDidMount(true);
        return () => {
            hookForm.form.setFormDidMount(false);
        };
    }, []);
    return hookForm;
}
